// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F9Fs","colBig":"styles_colBig__93Lis","colSmall":"styles_colSmall__rZOwl"};